'use client'
import useTryDemo from '@/components/hooks/use-try-demo'
import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { type FC } from 'react'

const TryDemoPage: FC = () => {
  const { loading, onSubmit } = useTryDemo({ openInNewTab: false })
  const searchParams = useSearchParams()
  const t = useTranslations('Pages.TryDemo')

  return (
    <section className="container flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 py-20 text-center md:px-6">
      <h1 className="text-balance text-3xl font-bold tracking-tight text-neutral-900 md:text-4xl">{t('title')}</h1>
      <p className="max-w-xl text-lg text-neutral-600">{t('description')}</p>
      <Button size="lg" className="gap-2" disabled={loading} aria-busy={loading} onClick={() => onSubmit(searchParams.get('source') || undefined)}>
        {loading ? t('loading') : t('cta')}
        {!loading && <ArrowRight aria-hidden className="h-5 w-5" />}
      </Button>
    </section>
  )
}

export default TryDemoPage
